(function () {
    function initBackToTop() {
        var btn = document.getElementById('lgnd-back-to-top-btn');
        if (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initBackToTop();
        });
    } else {
        initBackToTop();
    }
})();